import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgChemistryFlask = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.404 3.004v3.712a7.35 7.35 0 0 1 4.94 6.94A7.346 7.346 0 0 1 12 21a7.346 7.346 0 0 1-7.345-7.345 7.35 7.35 0 0 1 4.94-6.94V3.004M8.379 3h7.347"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.736 14.365c1.521.885 3.968 1.217 7.728-.677 3.083-1.535 5.281-1.59 6.802-1.078"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgChemistryFlask);
export default ForwardRef;
